import { Component, OnInit } from '@angular/core';
import { UserService } from "../../services/user/user.service";
import { HelperService } from "../../services/helper/helper.service";
import { LocalStorage } from '@ngx-pwa/local-storage';
import { ToastComponent } from '../toast/toast.component';
import { MatSnackBar } from '@angular/material';
import {Router} from "@angular/router";
import { AccountsService } from 'src/app/services/accounts/accounts.service';




@Component({
	selector: 'app-dashboard',
	templateUrl: './dashboard.component.html',
	styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {

	public loading = false;
	private jwt : string;
	private peers;
	private usersCrm = [];
	private permissions;
	private rules;
    private domain_permissions_rules;
    public user;
    private callsReport;
    private peerUsers;
    private users;
    public account;

    public atualPage = 'principal';

	constructor(
        private userService: UserService,
        private helperService: HelperService,
		protected localStorage: LocalStorage,
		private snackBar: MatSnackBar,
        private router: Router,
        private accountsService : AccountsService
    ) { }
    

	ngOnInit() {
        this.init();
    }
    
    init(){
        this.loading = true;
        this.helperService.init().then((res)=>{
            this.loading = false;
            if(res){
                this.user = res;
            }else{
                this.snackBar.openFromComponent(ToastComponent, {
                    data: "Assinatura Inválida"
                });
                this.router.navigate(['/notfound']);
            }
        })
    }


}
